import React from 'react'

const SortDropdown = ({
  showSortDropdown,
  sortBy,
  setSortBy,
  sortDirection,
  handleToggleSortDirection,
  user,
  setShowSortDropdown,
}) => {
  if (!showSortDropdown) return null

  return (
    <div className="absolute right-0 top-full mt-1 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-50">
      <div className="p-2">
        <div className="text-sm font-medium text-gray-700 mb-2">Sort by</div>
        <div className="space-y-1">
          <button
            className={`w-full text-left px-3 py-2 rounded-md flex justify-between items-center ${sortBy === 'created_at' ? 'bg-gray-100' : 'hover:bg-gray-50'}`}
            onClick={() => {
              setSortBy('created_at')
              setShowSortDropdown(false)
            }}
          >
            <span>Date Added</span>
            {sortBy === 'created_at' && (
              <div
                role="button"
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation()
                  handleToggleSortDirection()
                }}
                aria-label={`Sort ${sortDirection === 'desc' ? 'ascending' : 'descending'}`}
              >
                {sortDirection === 'desc' ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            )}
          </button>

          <button
            className={`w-full text-left px-3 py-2 rounded-md flex justify-between items-center ${sortBy === 'avg_rating' ? 'bg-gray-100' : 'hover:bg-gray-50'}`}
            onClick={() => {
              setSortBy('avg_rating')
              setShowSortDropdown(false)
            }}
          >
            <span>Average Rating</span>
            {sortBy === 'avg_rating' && (
              <div
                role="button"
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation()
                  handleToggleSortDirection()
                }}
                aria-label={`Sort ${sortDirection === 'desc' ? 'ascending' : 'descending'}`}
              >
                {sortDirection === 'desc' ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            )}
          </button>

          {user && (
            <button
              className={`w-full text-left px-3 py-2 rounded-md flex justify-between items-center ${sortBy === 'personal_rating' ? 'bg-gray-100' : 'hover:bg-gray-50'}`}
              onClick={() => {
                setSortBy('personal_rating')
                setShowSortDropdown(false)
              }}
            >
              <span>Your Rating</span>
              {sortBy === 'personal_rating' && (
                <div
                  role="button"
                  className="text-gray-500 hover:text-gray-700 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation()
                    handleToggleSortDirection()
                  }}
                  aria-label={`Sort ${sortDirection === 'desc' ? 'ascending' : 'descending'}`}
                >
                  {sortDirection === 'desc' ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </div>
              )}
            </button>
          )}

          <button
            className={`w-full text-left px-3 py-2 rounded-md flex justify-between items-center ${sortBy === 'cooking_time' ? 'bg-gray-100' : 'hover:bg-gray-50'}`}
            onClick={() => {
              setSortBy('cooking_time')
              setShowSortDropdown(false)
            }}
          >
            <span>Cooking Time</span>
            {sortBy === 'cooking_time' && (
              <div
                role="button"
                className="text-gray-500 hover:text-gray-700 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation()
                  handleToggleSortDirection()
                }}
                aria-label={`Sort ${sortDirection === 'desc' ? 'ascending' : 'descending'}`}
              >
                {sortDirection === 'desc' ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default SortDropdown
